import { useParams, Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import ArticleCard from '@/components/base/ArticleCard';
import SEOMeta from '@/components/base/SEOMeta';
import StructuredData from '@/components/base/StructuredData';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const [activeSlug, setActiveSlug] = useState(slug || 'yulequan');

  useEffect(() => {
    window.scrollTo(0, 0);
    if (slug) setActiveSlug(slug);
  }, [slug]);

  const filteredArticles = articles.filter((a) => a.category === activeSlug);
  const currentCategory = categories.find((c) => c.slug === activeSlug) || categories[0];

  return (
    <>
      <SEOMeta
        title={`${currentCategory.name}黑料 - 黑料大全`}
        description={`黑料大全${currentCategory.name}频道，收录最新最全的${currentCategory.description}，持续更新热门${currentCategory.name}黑料内容。`}
        keywords={`${currentCategory.name}黑料,${currentCategory.name}爆料,${currentCategory.name}八卦,黑料大全`}
        canonicalUrl={`https://heiliao.com/category/${activeSlug}`}
        ogImage="https://readdy.ai/api/search-image?query=Breaking%20news%20category%20page%20with%20red%20and%20black%20theme%2C%20gossip%20headlines%2C%20dramatic%20media%20layout&width=1200&height=630&seq=category-og&orientation=landscape"
        ogImageAlt={`${currentCategory.name}黑料分类页`}
      />
      <StructuredData
        data={{
          '@context': 'https://schema.org',
          '@type': 'CollectionPage',
          name: `${currentCategory.name} - 黑料大全`,
          description: `黑料大全${currentCategory.name}频道，收录最新最全的${currentCategory.description}`,
          url: `https://heiliao.com/category/${activeSlug}`,
          isPartOf: {
            '@type': 'WebSite',
            name: '黑料大全',
            url: 'https://heiliao.com',
          },
        }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-20">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: currentCategory.name },
            ]}
          />

          {/* Category Header */}
          <section className="w-full max-w-7xl mx-auto px-4 md:px-6 pb-8">
            <div className="flex items-center gap-4 mb-6">
              <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-500">
                <i className={`${currentCategory.icon} text-background-50 text-2xl`}></i>
              </span>
              <div>
                <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
                  {currentCategory.name}
                  <span className="text-primary-500">黑料</span>
                </h1>
                <p className="text-sm text-foreground-600 mt-1">{currentCategory.description}</p>
              </div>
            </div>

            {/* Category Tabs */}
            <div className="flex items-center gap-2 flex-wrap pb-4 border-b border-background-200/70">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                    activeSlug === cat.slug
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-700 hover:bg-background-200 border border-background-200/70'
                  }`}
                >
                  <i className={`${cat.icon} mr-1.5`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>
          </section>

          {/* Article List */}
          <section className="w-full max-w-7xl mx-auto px-4 md:px-6 py-8">
            {filteredArticles.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-product-shop="">
                {filteredArticles.map((article) => (
                  <ArticleCard key={article.id} article={article} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <span className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-background-200 mb-4">
                  <i className="ri-inbox-line text-foreground-400 text-2xl"></i>
                </span>
                <p className="text-foreground-600">该分类暂无内容，敬请期待</p>
              </div>
            )}
          </section>

          {/* Related Categories */}
          <section className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10">
            <h3 className="text-lg font-bold text-foreground-950 mb-4 font-heading">
              浏览其他分类
            </h3>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3">
              {categories
                .filter((c) => c.slug !== activeSlug)
                .map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="flex flex-col items-center gap-2 p-4 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer text-center"
                  >
                    <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100">
                      <i className={`${cat.icon} text-primary-600 text-lg`}></i>
                    </span>
                    <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">
                      {cat.name}
                    </span>
                  </Link>
                ))}
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}